<template>
  <div v-loading="loading" class="content-container">
    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title"
                >Báo cáo tình trạng phòng và dịch vụ đăc biệt</span
              >
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              dom-layout="scroll"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              class="agGrid"
              :auto-size-cell="true"
            />
            <!-- aggridReport -->
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Phòng: Hiển thị số phòng</li>
            <li>Hạng phòng: hiển thị tên hạng phòng</li>
            <li>
              Trạng thái phòng: Hiển thị 1 trong 5 trạng thái (Repaired,
              Occupied, Dirty, Clean, Ready)
            </li>
            <li>
              Giờ đến: Hiển thị thời gian nhân viên đến kiểm tra. Format: HHMMSS
            </li>
            <li>
              Dịch vụ đặc biệt: Hiển thị số lượng, mã dịch vụ phòng đang sử dụng
            </li>
            <li>Ghi chú: hiển thị ghi chú của đặt phòng</li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import InfoBtn from './components/InfoBtn.vue'
import {
  getDailyRoomReportApi,
  getDailyRoomReportApiExcel
} from '@/api/report_service/report_b'

export default {
  components: { InfoBtn },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        wrapText: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      loading: false,

      dialogFormVisible: false,
      hotelList: [],
      searchParams: {
        hotelId: ''
      },
      datetimeRange: { start: '2023-12-12', end: '2023-12-15' },

      columns: [
        {
          headerName: this.$t('grid.column.room'),
          field: 'room_num',
          tooltipField: 'room_num',
          sortable: false
        },
        {
          headerName: this.$t('grid.column.roomLevel'),
          headerTooltip: this.$t('grid.column.roomLevel'),
          field: 'room_level_nm',
          tooltipField: 'room_level_nm',
          // width: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.roomStatus'),
          headerTooltip: this.$t('grid.column.roomStatus'),
          field: 'room_status_nm',
          tooltipField: 'room_status_nm',
          sortable: false
        },
        {
          headerName: this.$t('grid.column.arrivalHour'),
          field: 'arrive_depart_time',
          valueGetter: params => {
            if (params.data.arrive_depart_time) {
              return this.$moment(params.data.arrive_depart_time).format(
                'DD-MM-YYYY HH:mm'
              )
            }
          },
          tooltipField: 'arrive_depart_time',
          sortable: false
        },
        {
          headerName: this.$t('grid.column.specialService'),
          headerTooltip: this.$t('grid.column.specialService'),
          field: 'special_service_desc',
          tooltipField: 'special_service_desc',
          sortable: false
        },
        {
          headerName: this.$t('grid.column.note'),
          field: 'note',
          tooltipField: 'note',
          sortable: false
        }
      ],
      rows: []
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    handleCommand(cmmd) {
      if (cmmd === 'excel') {
        getDailyRoomReportApiExcel(this.searchParams).then(res => {
          if (res) {
            const date = this.$moment().format('DD-MM-YYYY')
            const href = URL.createObjectURL(res)
            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              'tinh_trang_phong_hang_ngay_report_' + date + '.xlsx'
              // res.headers['content-disposition'].split('filename=')[1],
            ) // or any other extension
            document.body.appendChild(link)
            link.click()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
      }
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30

      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    async getList() {
      this.loading = true
      await getDailyRoomReportApi()
        .then(res => {
          this.rows = res.data
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss"></style>
